module.exports = __webpack_public_path__ + "static/media/kohlrabi.66809364.png";